import { creditAssessment, } from "@wayke-se/ecom";
export default (caseId, callback) => {
    creditAssessment.getStatus(caseId).then(callback).catch(callback);
};
